export class KeyValue {
    constructor(text, value){
        this.text = text;
        this.value = value;
    }

    text: string;
    value: string;
}



// WEBPACK FOOTER //
// ./src/models/keyValue.model.js